export const PERSONAL_DATA_FIELDS = ['firstName', 'lastName', 'zipCode', 'city', 'street', 'houseNumber', 'iban', 'bank'];